import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CallsReportFilterForm } from 'src/app/shared/interfaces';

import { Constants } from '../../common';
import { DataWithPagination } from '../../interface';
import { Mapper } from '../mapper/mapper';
import { CallReport } from '../model/call-report-model';
import { BaseAPI } from './base-api';

@Injectable({
  providedIn: 'root',
})
export class CallsReportApi {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  getCallsReport(filter: CallsReportFilterForm): Observable<DataWithPagination<CallReport[]>> {
    return this.baseAPI.post(Constants.GET_CALLS_REPORT_API_URL, filter).pipe(
      map((res) => {
        const data: DataWithPagination<CallReport[]> = {
          data: this.mapper.fromListJson(CallReport, res.items),
          count: res.count,
        };
        return data;
      })
    );
  }
}
